var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurnitureOpacityGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 633.877,
    height: 314.024,
    viewBox: "0 0 633.877 314.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-150.651 -270.153)",
    opacity: 0.162
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823.006,584.307a217.934,217.934,0,0,0,17.523-45.427c18.9-72.7-11.5-131.131-72.652-165.3-29.085-16.274-55.929-18.517-79.2-16.484-26.453,2.311-48.286,10.16-63.543,9.216-15.433-.957-26.163-15.028-42.5-32.084-20.907-21.857-49.466-46.54-104.613-57.53-59.827-11.931-156.691-10.835-190.56,36.074-23.616,32.687-6.967,75.691,14.325,109.885,30.178,48.461-9.312,56.907-45,76.126-27.09,14.595-51.988,36.253-42.513,85.52Z",
    transform: "translate(-61.573 -0.13)",
    fill: "#d2e4ff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.794,931.395c15.324-62.043-3.469-113.7-45.423-148.744h-262.9l.834,194.17h290.84A224.65,224.65,0,0,0,1754.794,931.395Z",
    transform: "translate(-975.56 -392.644)",
    fill: "#d2e4ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.294,0H75.6A11.293,11.293,0,0,1,86.894,11.293V193.966A11.293,11.293,0,0,1,75.6,205.259H11.294A11.294,11.294,0,0,1,0,193.965V11.294A11.294,11.294,0,0,1,11.294,0Z",
    transform: "translate(658.352 582.886) rotate(180)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.327,783.122H281.3a221.012,221.012,0,0,0,16.016,32.414c28.673,48.461-8.848,56.907-42.752,76.126-25.739,14.595-49.395,36.253-40.393,85.52H487.327Z",
    transform: "translate(-61.573 -393.005)",
    fill: "#d2e4ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.896 400.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1482.65,990.494a2.723,2.723,0,0,0,2.716,2.716h86.616v-5.432h-20.5V973.2l-3.356-3.357v-1.393h-3.89l-.145,1.559-3.412,3.356v14.41h-7.708V973.2l-3.357-3.357v-1.393h-3.889l-.148,1.559-3.411,3.356v14.41h-5.086V973.2l-3.357-3.357v-1.393h-3.889l-.147,1.559-3.411,3.356v14.41h-5.122V973.2l-3.356-3.357v-1.393h-3.887l-.148,1.559-3.411,3.356v14.41h-4.988a2.72,2.72,0,0,0-2.716,2.716Z",
    transform: "translate(-1482.65 -935.144)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.65,1170.541a2.725,2.725,0,0,0,2.716,2.718h86.616v-5.435H1546.8v-9.889h-12.233v9.889h-3.149v-9.889h-12.234v9.889h-2.623v-9.889h-12.233v9.889h-3.17v-9.889h-12.233v9.889h-3.557a2.725,2.725,0,0,0-2.716,2.716Z",
    transform: "translate(-1482.65 -1080.313)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.65,1320.068a2.723,2.723,0,0,0,2.716,2.716h86.616v-5.432H1556.43a4.9,4.9,0,0,0,4.864-4.435l1.171.826v-2.971l-1.182,1.135a4.9,4.9,0,0,0-4.853-4.327h-9.889a4.9,4.9,0,0,0-4.823,4.109l-.955-.917v2.971l.933-.658a4.9,4.9,0,0,0,4.844,4.268h-14.315a4.9,4.9,0,0,0,4.866-4.435l1.168.826v-2.971l-1.182,1.135a4.9,4.9,0,0,0-4.853-4.327h-9.889a4.9,4.9,0,0,0-4.822,4.109l-.955-.917v2.971l.934-.658a4.9,4.9,0,0,0,4.844,4.268h-16.107a4.9,4.9,0,0,0,4.864-4.435l1.171.826v-2.971l-1.182,1.135a4.9,4.9,0,0,0-4.854-4.327h-9.889a4.9,4.9,0,0,0-4.823,4.109l-.955-.917v2.971l.933-.658a4.9,4.9,0,0,0,4.844,4.268h-10.974a2.72,2.72,0,0,0-2.716,2.716Z",
    transform: "translate(-1482.65 -1194.961)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.65,1443.06a2.723,2.723,0,0,0,2.716,2.716h86.616v-5.432h-22.505v-12.915a4.475,4.475,0,0,0-2.678-4.1.407.407,0,0,0,.176-.334.412.412,0,0,0-.409-.409h-2.971a.409.409,0,0,0-.277.711,4.321,4.321,0,0,0-2.635,3.981v13.063h-3.31v-12.915a4.476,4.476,0,0,0-2.679-4.1.406.406,0,0,0,.176-.334.412.412,0,0,0-.41-.409h-2.971a.41.41,0,0,0-.277.711,4.32,4.32,0,0,0-2.635,3.981v13.063h-3.385v-12.915a4.476,4.476,0,0,0-2.679-4.1.407.407,0,0,0,.176-.334.411.411,0,0,0-.41-.409h-2.974a.408.408,0,0,0-.275.711,4.323,4.323,0,0,0-2.637,3.981v13.063h-3.418v-12.915a4.476,4.476,0,0,0-2.679-4.1.406.406,0,0,0,.176-.334.412.412,0,0,0-.41-.409h-2.974a.408.408,0,0,0-.275.711,4.323,4.323,0,0,0-2.637,3.981v13.063h-3.2v-12.915a4.475,4.475,0,0,0-2.679-4.1.406.406,0,0,0,.176-.334.411.411,0,0,0-.409-.409h-2.974a.408.408,0,0,0-.275.711,4.323,4.323,0,0,0-2.637,3.981v13.063h-6.816a2.72,2.72,0,0,0-2.716,2.716Z",
    transform: "translate(-1482.65 -1283.074)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.211,830.861a4.47,4.47,0,0,0-2.677-4.094.408.408,0,0,0-.235-.744h-2.971a.408.408,0,0,0-.277.709,4.324,4.324,0,0,0-2.635,3.982v13.063h8.8Z",
    transform: "translate(-1513.882 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.5,830.861a4.471,4.471,0,0,0-2.677-4.094.409.409,0,0,0-.235-.744h-2.971a.408.408,0,0,0-.277.709,4.325,4.325,0,0,0-2.635,3.982v13.063h8.8Z",
    transform: "translate(-1553.18 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.737,830.861a4.47,4.47,0,0,0-2.677-4.094.409.409,0,0,0-.235-.744h-2.972a.408.408,0,0,0-.276.709,4.325,4.325,0,0,0-2.636,3.982v13.063h8.8Z",
    transform: "translate(-1593.197 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.822,830.861a4.471,4.471,0,0,0-2.677-4.094.408.408,0,0,0-.235-.744h-2.971a.408.408,0,0,0-.277.709,4.325,4.325,0,0,0-2.636,3.982v13.063h8.8Z",
    transform: "translate(-1633.101 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.587,830.861a4.471,4.471,0,0,0-2.678-4.094.408.408,0,0,0-.234-.744H1733.7a.408.408,0,0,0-.276.709,4.324,4.324,0,0,0-2.635,3.982v13.063h8.8Z",
    transform: "translate(-1672.76 -826.023)",
    fill: "#c7deff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(671.756 400.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2305.287,990.494A2.723,2.723,0,0,0,2308,993.21h86.616v-5.432h-20.5V973.2l-3.356-3.357v-1.393h-3.89l-.145,1.559-3.411,3.356v14.41h-7.708V973.2l-3.357-3.357v-1.393h-3.889l-.148,1.559-3.411,3.356v14.41h-5.086V973.2l-3.357-3.357v-1.393h-3.889l-.148,1.559-3.411,3.356v14.41h-5.122V973.2l-3.356-3.357v-1.393h-3.887l-.147,1.559-3.412,3.356v14.41H2308a2.72,2.72,0,0,0-2.716,2.716Z",
    transform: "translate(-2305.287 -935.144)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.287,1170.541a2.725,2.725,0,0,0,2.716,2.718h86.616v-5.435h-25.184v-9.889H2357.2v9.889h-3.15v-9.889H2341.82v9.889H2339.2v-9.889h-12.233v9.889h-3.17v-9.889H2311.56v9.889H2308a2.725,2.725,0,0,0-2.716,2.716Z",
    transform: "translate(-2305.287 -1080.313)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.287,1320.068a2.723,2.723,0,0,0,2.716,2.716h86.616v-5.432h-15.552a4.9,4.9,0,0,0,4.864-4.435l1.171.826v-2.971l-1.182,1.135a4.9,4.9,0,0,0-4.853-4.327h-9.89a4.9,4.9,0,0,0-4.822,4.109l-.956-.917v2.971l.933-.658a4.9,4.9,0,0,0,4.844,4.268h-14.315a4.906,4.906,0,0,0,4.867-4.435l1.168.826v-2.971l-1.182,1.135a4.9,4.9,0,0,0-4.853-4.327h-9.889a4.9,4.9,0,0,0-4.822,4.109l-.955-.917v2.971l.933-.658a4.9,4.9,0,0,0,4.844,4.268h-16.107a4.9,4.9,0,0,0,4.865-4.435l1.171.826v-2.971l-1.182,1.135a4.9,4.9,0,0,0-4.854-4.327h-9.889a4.9,4.9,0,0,0-4.823,4.109l-.955-.917v2.971l.933-.658a4.9,4.9,0,0,0,4.844,4.268H2308a2.72,2.72,0,0,0-2.716,2.716Z",
    transform: "translate(-2305.287 -1194.961)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.287,1443.06a2.723,2.723,0,0,0,2.716,2.716h86.616v-5.432h-22.506v-12.915a4.476,4.476,0,0,0-2.678-4.1.406.406,0,0,0,.176-.334.411.411,0,0,0-.41-.409h-2.971a.41.41,0,0,0-.277.711,4.321,4.321,0,0,0-2.634,3.981v13.063h-3.31v-12.915a4.476,4.476,0,0,0-2.679-4.1.406.406,0,0,0,.176-.334.411.411,0,0,0-.409-.409h-2.971a.41.41,0,0,0-.277.711,4.321,4.321,0,0,0-2.635,3.981v13.063h-3.385v-12.915a4.475,4.475,0,0,0-2.678-4.1.406.406,0,0,0,.176-.334.411.411,0,0,0-.409-.409h-2.973a.408.408,0,0,0-.275.711,4.323,4.323,0,0,0-2.637,3.981v13.063h-3.418v-12.915a4.475,4.475,0,0,0-2.679-4.1.406.406,0,0,0,.176-.334.411.411,0,0,0-.41-.409h-2.973a.408.408,0,0,0-.275.711,4.323,4.323,0,0,0-2.637,3.981v13.063h-3.2v-12.915a4.476,4.476,0,0,0-2.679-4.1.406.406,0,0,0,.177-.334.412.412,0,0,0-.409-.409h-2.974a.409.409,0,0,0-.275.711,4.323,4.323,0,0,0-2.636,3.981v13.063H2308a2.72,2.72,0,0,0-2.716,2.716Z",
    transform: "translate(-2305.287 -1283.074)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354.848,830.861a4.47,4.47,0,0,0-2.677-4.094.408.408,0,0,0-.234-.744h-2.972a.408.408,0,0,0-.276.709,4.325,4.325,0,0,0-2.635,3.982v13.063h8.795Z",
    transform: "translate(-2336.52 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406.141,830.861a4.47,4.47,0,0,0-2.677-4.094.408.408,0,0,0-.234-.744h-2.972a.408.408,0,0,0-.277.709,4.325,4.325,0,0,0-2.635,3.982v13.063h8.8Z",
    transform: "translate(-2375.817 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2458.376,830.861a4.47,4.47,0,0,0-2.678-4.094.409.409,0,0,0-.234-.744h-2.972a.408.408,0,0,0-.277.709,4.324,4.324,0,0,0-2.635,3.982v13.063h8.8Z",
    transform: "translate(-2415.835 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510.461,830.861a4.47,4.47,0,0,0-2.677-4.094.408.408,0,0,0-.234-.744h-2.971a.408.408,0,0,0-.277.709,4.324,4.324,0,0,0-2.635,3.982v13.063h8.795Z",
    transform: "translate(-2455.74 -826.023)",
    fill: "#c7deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2562.225,830.861a4.47,4.47,0,0,0-2.677-4.094.408.408,0,0,0-.235-.744h-2.972a.408.408,0,0,0-.276.709,4.324,4.324,0,0,0-2.635,3.982v13.063h8.8Z",
    transform: "translate(-2495.399 -826.023)",
    fill: "#c7deff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.253 289.742)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.382,
    height: 49.239,
    rx: 1.691,
    transform: "translate(23.125 49.239) rotate(180)",
    fill: "#d2e4ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.369,525.994c12.324,0,22.315,10.564,22.315,23.6h-44.63C1047.054,536.558,1057.045,525.994,1069.369,525.994Z",
    transform: "translate(-1047.054 -485.751)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.873,526.525a9.175,9.175,0,0,1,1.959-.214c8.03,0,14.539,10.531,14.539,23.522h-3.919C1147.452,537.918,1141.975,528.073,1134.873,526.525Z",
    transform: "translate(-1114.336 -485.994)",
    fill: "#ffc48a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(464.571 305.358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1567.231,420.692v32.044a1.582,1.582,0,0,0,1.576,1.578h.229a1.582,1.582,0,0,0,1.577-1.578V423.982c-.348-.348-.7-.693-1.052-1.041Q1568.418,421.819,1567.231,420.692Z",
    transform: "translate(-1547.487 -420.692)",
    fill: "#d2e4ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.119,525.994c12.324,0,22.315,10.564,22.315,23.6H1482.8C1482.8,536.558,1492.795,525.994,1505.119,525.994Z",
    transform: "translate(-1482.804 -501.368)",
    fill: "#b74b42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.623,526.525a9.173,9.173,0,0,1,1.959-.214c8.03,0,14.539,10.531,14.539,23.522h-3.92C1583.2,537.918,1577.726,528.073,1570.623,526.525Z",
    transform: "translate(-1550.086 -501.611)",
    fill: "#cc6f6a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.641 289.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.691,0h0A1.691,1.691,0,0,1,3.382,1.691V47.548a1.691,1.691,0,0,1-1.691,1.691h0A1.691,1.691,0,0,1,0,47.548V1.691A1.691,1.691,0,0,1,1.691,0Z",
    transform: "translate(23.125 49.239) rotate(180)",
    fill: "#d2e4ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.3,525.994c12.324,0,22.315,10.564,22.315,23.6h-44.63C601.988,536.558,611.979,525.994,624.3,525.994Z",
    transform: "translate(-601.988 -485.751)",
    fill: "#b74b42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.806,526.525a9.176,9.176,0,0,1,1.96-.214c8.03,0,14.539,10.531,14.539,23.522h-3.92C702.385,537.918,696.908,528.073,689.806,526.525Z",
    transform: "translate(-669.269 -485.994)",
    fill: "#cc6f6a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M517.891,312.646H776.276c-17.646-14.667-41.6-28.58-77.33-36.074a308.231,308.231,0,0,0-46.358-5.976q-5.035-.267-10.1-.376-3.037-.063-6.079-.066c-5.014-.009-10.03.112-15.015.368q-2.654.132-5.294.317c-21.57,1.512-42.351,5.595-59.887,12.893C540.031,290.462,526.614,299.931,517.891,312.646Z",
    transform: "translate(-295.756)",
    fill: "#d2e4ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.79,907.373H730.8a2.716,2.716,0,0,0,0-5.432H564.638Z",
    transform: "translate(-324.778 -484.037)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.825,1056.518H770.783a2.716,2.716,0,0,0,0-5.432H617.474A27.5,27.5,0,0,1,616.825,1056.518Z",
    transform: "translate(-364.133 -598.302)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.507,1205.656H633.4a2.717,2.717,0,0,0,0-5.435H448.054C444.632,1202.011,441.09,1203.8,437.507,1205.656Z",
    transform: "translate(-234.171 -712.56)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.263,1354.8H490.712a2.716,2.716,0,0,0,0-5.432H254.982A61.009,61.009,0,0,0,251.263,1354.8Z",
    transform: "translate(-91.483 -826.827)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.232,1503.943H460.809a2.716,2.716,0,0,0,0-5.432H212.426Q212.244,1501.153,212.232,1503.943Z",
    transform: "translate(-61.58 -941.092)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.828,1000.064h0a2.649,2.649,0,0,0,2.641-2.641V817.056a2.649,2.649,0,0,0-2.641-2.641h0a2.649,2.649,0,0,0-2.641,2.641V997.423A2.649,2.649,0,0,0,914.828,1000.064Z",
    transform: "translate(-588.75 -416.98)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.067,826.767a.408.408,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.324,4.324,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.47,4.47,0,0,1,1211.067,826.767Z",
    transform: "translate(-812.162 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.775,826.767a.408.408,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.47,4.47,0,0,1,1159.775,826.767Z",
    transform: "translate(-773.465 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.541,826.767a.408.408,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.471,4.471,0,0,1,1107.541,826.767Z",
    transform: "translate(-734.058 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.455,826.767a.409.409,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.471,4.471,0,0,1,1055.455,826.767Z",
    transform: "translate(-694.764 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.692,826.767a.408.408,0,0,1,.235-.744h2.972a.408.408,0,0,1,.276.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.47,4.47,0,0,1,1003.692,826.767Z",
    transform: "translate(-655.713 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.067,1423.336a.409.409,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.324,4.324,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,1211.067,1423.336Z",
    transform: "translate(-812.162 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.775,1423.336a.409.409,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,1159.775,1423.336Z",
    transform: "translate(-773.465 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.541,1423.336a.409.409,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,1107.541,1423.336Z",
    transform: "translate(-734.058 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.455,1423.336a.409.409,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,1055.455,1423.336Z",
    transform: "translate(-694.764 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.692,1423.336a.409.409,0,0,1,.235-.744h2.972a.408.408,0,0,1,.276.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.469,4.469,0,0,1,1003.692,1423.336Z",
    transform: "translate(-655.713 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(396.082 433.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1214.105,968.451h-3.118v1.394l-3.357,3.357v14.575h2.99l3.65-17.62Z",
    transform: "translate(-1207.63 -968.451)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.9,970.01v-1.559h.77l.147,1.559,3.411,3.356v14.41h-7.813v-14.41Z",
    transform: "translate(-1217.426 -968.451)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.357 433.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1146.01,968.451h-3.118v1.394l-3.357,3.357v14.575h2.99l3.65-17.62Z",
    transform: "translate(-1139.535 -968.451)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.8,970.01v-1.559h.77l.147,1.559,3.412,3.356v14.41h-7.814v-14.41Z",
    transform: "translate(-1149.33 -968.451)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.667 433.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1078.057,968.451h-3.118v1.394l-3.356,3.357v14.575h2.99l3.65-17.62Z",
    transform: "translate(-1071.583 -968.451)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.852,970.01v-1.559h.77l.147,1.559,3.412,3.356v14.41h-7.814v-14.41Z",
    transform: "translate(-1081.377 -968.451)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.956 503.215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.222,1266.73H499.1v1.394l-3.356,3.356v14.575h2.99l3.65-17.62Z",
    transform: "translate(-495.748 -1266.73)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.016,1268.289v-1.559h.77l.147,1.559,3.411,3.357v14.41h-7.814v-14.41Z",
    transform: "translate(-505.541 -1266.73)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.064 503.215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.269,1266.73h-3.118v1.394l-3.357,3.356v14.575h2.989l3.65-17.62Z",
    transform: "translate(-427.794 -1266.73)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.063,1268.289v-1.559h.77l.147,1.559,3.411,3.357v14.41h-7.814v-14.41Z",
    transform: "translate(-437.588 -1266.73)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(343.225 433.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998.9,968.451h-3.118v1.394l-3.357,3.357v14.575h2.99l3.65-17.62Z",
    transform: "translate(-992.429 -968.451)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.7,970.01v-1.559h.771l.147,1.559,3.411,3.356v14.41h-7.814v-14.41Z",
    transform: "translate(-1002.224 -968.451)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(408.345 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(392.167 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(376.562 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(360.405 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384.629 512.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1169.93,1317.352h9.89a4.9,4.9,0,0,0,4.886-4.886h0a4.9,4.9,0,0,0-4.886-4.886h-9.89a4.9,4.9,0,0,0-4.886,4.886h0A4.9,4.9,0,0,0,1169.93,1317.352Z",
    transform: "translate(-1163.896 -1307.579)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.091,1321.227v2.971l-1.783-1.257Z",
    transform: "translate(-1225.389 -1318.035)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.134,1321.227v2.971l1.783-1.257Z",
    transform: "translate(-1160.134 -1318.035)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.303 512.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1058.768,1317.352h9.89a4.9,4.9,0,0,0,4.886-4.886h0a4.9,4.9,0,0,0-4.886-4.886h-9.89a4.9,4.9,0,0,0-4.886,4.886h0A4.9,4.9,0,0,0,1058.768,1317.352Z",
    transform: "translate(-1052.734 -1307.579)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.931,1321.227v2.971l-1.783-1.257Z",
    transform: "translate(-1114.229 -1318.035)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.972,1321.227v2.971l1.783-1.257Z",
    transform: "translate(-1048.972 -1318.035)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.861 512.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.271,1317.352h9.89a4.9,4.9,0,0,0,4.886-4.886h0a4.9,4.9,0,0,0-4.886-4.886h-9.89a4.9,4.9,0,0,0-4.887,4.886h0A4.9,4.9,0,0,0,955.271,1317.352Z",
    transform: "translate(-949.236 -1307.579)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.433,1321.227v2.971l-1.783-1.257Z",
    transform: "translate(-1010.731 -1318.035)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.474,1321.227v2.971l1.783-1.257Z",
    transform: "translate(-945.474 -1318.035)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M830.232,826.767a.408.408,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.47,4.47,0,0,1,830.232,826.767Z",
    transform: "translate(-524.85 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.939,826.767a.408.408,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.471,4.471,0,0,1,778.939,826.767Z",
    transform: "translate(-486.154 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.705,826.767a.408.408,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.471,4.471,0,0,1,726.705,826.767Z",
    transform: "translate(-446.748 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.618,826.767a.408.408,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.471,4.471,0,0,1,674.618,826.767Z",
    transform: "translate(-407.452 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.855,826.767a.408.408,0,0,1,.235-.744h2.972a.408.408,0,0,1,.276.709,4.325,4.325,0,0,1,2.635,3.982v13.063h-8.8V830.861A4.47,4.47,0,0,1,622.855,826.767Z",
    transform: "translate(-374.122 -425.873)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.232,1423.336a.409.409,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,830.232,1423.336Z",
    transform: "translate(-524.85 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.939,1423.336a.409.409,0,0,1,.234-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,778.939,1423.336Z",
    transform: "translate(-486.154 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.705,1423.336a.409.409,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,726.705,1423.336Z",
    transform: "translate(-446.748 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.618,1423.336a.409.409,0,0,1,.235-.744h2.972a.408.408,0,0,1,.277.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,674.618,1423.336Z",
    transform: "translate(-407.452 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.855,1423.336a.409.409,0,0,1,.235-.744h2.972a.408.408,0,0,1,.276.709,4.325,4.325,0,0,1,2.635,3.981v13.064h-8.8V1427.43A4.47,4.47,0,0,1,622.855,1423.336Z",
    transform: "translate(-374.122 -882.927)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.543 433.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.27,968.451h-3.118v1.394L826.8,973.2v14.575h2.99l3.65-17.62Z",
    transform: "translate(-826.795 -968.451)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.064,970.01v-1.559h.771l.147,1.559,3.411,3.356v14.41H839.58v-14.41Z",
    transform: "translate(-836.59 -968.451)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.818 433.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765.174,968.451h-3.118v1.394L758.7,973.2v14.575h2.99l3.65-17.62Z",
    transform: "translate(-758.699 -968.451)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.969,970.01v-1.559h.77l.147,1.559,3.412,3.356v14.41h-7.813v-14.41Z",
    transform: "translate(-768.494 -968.451)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.347 538.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.654,1415.875h-3.118v1.394l-3.357,3.357V1435.2h2.99l3.65-17.62Z",
    transform: "translate(-540.179 -1415.875)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.448,1417.434v-1.559h.77l.147,1.559,3.412,3.356v14.41h-7.814v-14.41Z",
    transform: "translate(-549.974 -1415.875)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.422 538.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.558,1415.875H475.44v1.394l-3.357,3.357V1435.2h2.99l3.65-17.62Z",
    transform: "translate(-472.083 -1415.875)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.353,1417.434v-1.559h.77l.147,1.559,3.412,3.356v14.41h-7.814v-14.41Z",
    transform: "translate(-481.878 -1415.875)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.533 538.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.787,1415.875h-3.118v1.394l-3.357,3.357V1435.2h2.99l3.65-17.62Z",
    transform: "translate(-391.312 -1415.875)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.581,1417.434v-1.559h.771l.147,1.559,3.412,3.356v14.41H404.1v-14.41Z",
    transform: "translate(-401.106 -1415.875)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.607 538.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.691,1415.875h-3.118v1.394l-3.356,3.357V1435.2h2.99l3.65-17.62Z",
    transform: "translate(-323.216 -1415.875)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.486,1417.434v-1.559h.771l.147,1.559,3.412,3.356v14.41H336v-14.41Z",
    transform: "translate(-333.012 -1415.875)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269.128 433.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.221,968.451H694.1v1.394l-3.356,3.357v14.575h2.99l3.65-17.62Z",
    transform: "translate(-690.747 -968.451)",
    fill: "#afd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.016,970.01v-1.559h.77l.147,1.559,3.412,3.356v14.41h-7.814v-14.41Z",
    transform: "translate(-700.541 -968.451)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(314.796 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(298.618 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(283.013 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.234,
    height: 9.889,
    transform: "translate(266.855 487.661) rotate(180)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.011 512.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.093,1317.352h9.89a4.9,4.9,0,0,0,4.886-4.886h0a4.9,4.9,0,0,0-4.886-4.886h-9.89a4.9,4.9,0,0,0-4.886,4.886h0A4.9,4.9,0,0,0,789.093,1317.352Z",
    transform: "translate(-783.059 -1307.579)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.255,1321.227v2.971l-1.783-1.257Z",
    transform: "translate(-844.553 -1318.035)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.3,1321.227v2.971l1.783-1.257Z",
    transform: "translate(-779.297 -1318.035)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.685 512.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.933,1317.352h9.89a4.9,4.9,0,0,0,4.886-4.886h0a4.9,4.9,0,0,0-4.886-4.886h-9.89a4.9,4.9,0,0,0-4.886,4.886h0A4.9,4.9,0,0,0,677.933,1317.352Z",
    transform: "translate(-671.898 -1307.579)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.094,1321.227v2.971l-1.783-1.257Z",
    transform: "translate(-733.392 -1318.035)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.136,1321.227v2.971l1.783-1.257Z",
    transform: "translate(-668.136 -1318.035)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.067 512.768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.435,1317.352h9.89a4.9,4.9,0,0,0,4.886-4.886h0a4.9,4.9,0,0,0-4.886-4.886h-9.89a4.9,4.9,0,0,0-4.886,4.886h0A4.9,4.9,0,0,0,574.435,1317.352Z",
    transform: "translate(-568.401 -1307.579)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.6,1321.227v2.971l-1.783-1.257Z",
    transform: "translate(-629.895 -1318.035)",
    fill: "#bdd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.638,1321.227v2.971l1.783-1.257Z",
    transform: "translate(-564.638 -1318.035)",
    fill: "#bdd8ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.189 467.304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1280.128,1267.18s.5-5.282-1.458-7.483-5.365-3.7-7.181-2.289-3.834,7.516-3.733,8.451S1280.128,1267.18,1280.128,1267.18Z",
    transform: "translate(-1222.162 -1223.258)",
    fill: "#d39d71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.107,1290.141l-1.949,24.695-16.109-1.671,2.435-24.595Z",
    transform: "translate(-1208.599 -1247.552)",
    fill: "#eab888"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.594 6.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1293.289,1168.007s-10.918-27.546-20.693-27.219c0,0-4.257,1.359.183,5.635S1293.289,1168.007,1293.289,1168.007Z",
    transform: "translate(-1270.058 -1140.785)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.421,1221.384s-17.837-14.158-21.774-11.117c0,0-2.224,1.484.4,2.745S1282.022,1215.937,1290.421,1221.384Z",
    transform: "translate(-1267.768 -1193.69)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355.2,1200.7c-.109-.158-6.715-15.39-4.115-15.449S1355.2,1200.7,1355.2,1200.7Z",
    transform: "translate(-1331.136 -1174.851)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.107,1249.95c-.057-.236-11.227-14.322-11.227-14.322s-3.569.031-4.3,2.122-2.9,1.461-3.935,2.474l13.589,15.824Z",
    transform: "translate(-1324.371 -1213.448)",
    fill: "#eab888"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.513 45.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1212,1343.088l6.094-.8a2.069,2.069,0,0,0,1.784-2.319l-2.1-16.079a2.069,2.069,0,0,0-2.32-1.784l-6.094.8a2.07,2.07,0,0,0-1.784,2.32l2.1,16.078A2.069,2.069,0,0,0,1212,1343.088Z",
    transform: "translate(-1207.559 -1318.402)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.72,1314.518l2.382-.311a.809.809,0,0,0,.7-.907l-.821-6.284a.809.809,0,0,0-.907-.7l-2.381.311a.808.808,0,0,0-.7.906l.821,6.284A.808.808,0,0,0,1219.72,1314.518Z",
    transform: "translate(-1215.548 -1306.313)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.679,
    height: 10.284,
    transform: "translate(9.837 16.827) rotate(172.559)",
    fill: "#f1a34f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.308 62.513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1263.477,1388.832l8.531-.452a1.01,1.01,0,0,0,.955-1.062l-.143-2.7a1.01,1.01,0,0,0-1.062-.955l-8.53.452a1.01,1.01,0,0,0-.955,1.062l.143,2.7A1.011,1.011,0,0,0,1263.477,1388.832Z",
    transform: "translate(-1262.271 -1383.663)",
    fill: "#699ff0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1276.466,1382.425l3.2-.17a.38.38,0,0,0,.359-.4l-.054-1.013a.38.38,0,0,0-.4-.359l-3.2.17a.38.38,0,0,0-.359.4l.054,1.013A.379.379,0,0,0,1276.466,1382.425Z",
    transform: "translate(-1272.799 -1380.484)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.563,
    height: 2.011,
    transform: "matrix(-0.999, 0.053, -0.053, -0.999, 10.673, 4.038)",
    fill: "#f1a34f"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 30.948,
    height: 43.572,
    transform: "translate(101.877 64.844) rotate(-164.294)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.869,
    height: 21.854,
    transform: "translate(77.97 66.374) rotate(177.231)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.982,
    height: 4.218,
    transform: "translate(90.927 65.301) rotate(177.232)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.11,1532.356a9,9,0,1,1-9,9A9,9,0,0,1,1131.11,1532.356Z",
    transform: "translate(-1110.583 -1434.326)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.023,1553.128a4.139,4.139,0,1,1-4.14,4.139A4.139,4.139,0,0,1,1147.023,1553.128Z",
    transform: "translate(-1126.495 -1450.24)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.894,1532.356a9,9,0,1,1-9,9A9,9,0,0,1,1437.894,1532.356Z",
    transform: "translate(-1345.622 -1434.326)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.808,1553.128a4.139,4.139,0,1,1-4.139,4.139A4.139,4.139,0,0,1,1453.808,1553.128Z",
    transform: "translate(-1361.535 -1450.24)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.784,1121.467a1.35,1.35,0,0,1,1.907-.071l11.515,10.686a1.351,1.351,0,0,1,.368.58l1.463,4.6,96.635,4.582a1.35,1.35,0,0,1,1.284,1.414l-1.979,40.663a1.351,1.351,0,0,1-1.25,1.281l-79.348,5.758c-.033,0-.066,0-.1,0a1.35,1.35,0,0,1-1.286-.94L1095.76,1139c-.007-.02-.014-.041-.02-.062l-1.63-5.121-11.255-10.444A1.349,1.349,0,0,1,1082.784,1121.467Zm27,52.716,8.874-.34-3.712-14.977-10.064-.085Zm11.262-.432,9.988-.383-3.376-14.4-10.3-.087Zm13.124,12.989-2.592-11.051-9.958.382,2.82,11.375Zm11.537-.837-1.984-10.68-9.763.374,2.573,10.971Zm12.715-.923-1.552-10.26-10.786.413,1.97,10.6Zm10.608-.77-.749-9.928-9.059.347,1.54,10.181Zm12.868-.933-.617-9.492-10.661.408.742,9.848Zm10.559-23.755-9.763-.083.774,11.92,8.429-.323Zm-12.108-.1-10.849-.092.945,12.531,10.685-.41Zm-12.058-16.128,1.033,13.7,10.874.092-.862-13.264Zm-13.908-.66,2.155,14.247,10.438.088-1.04-13.787Zm-14.465-.686,2.753,14.816,11.5.1-2.169-14.34Zm-14.007-.664,3.6,15.369,10.773.091-2.771-14.909Zm28.612,17.919-11.417-.1,2.546,13.7,10.865-.416Zm4.347,13.1,9.235-.354-.953-12.64-10.261-.087Zm-18.147-13.218-10.658-.09,3.35,14.284,9.876-.378Zm-13.616-2.454-3.626-15.463-10.639-.5,3.936,15.88Zm54.579-12.7.855,13.173,10.029.085.619-12.712Zm10.1,29.456-8.163.313.611,9.413,7.1-.515Zm-77.543,14.8,7.833-.569-2.84-11.456-8.714.334Zm-10.1-31.751,10.229.087-3.96-15.975-11.5-.545Z",
    transform: "translate(-1080.175 -1119.197)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.315,1121.611a1.619,1.619,0,0,0,1.072-2.833l-5.889-5.2a1.619,1.619,0,1,0-2.142,2.428l5.889,5.2A1.613,1.613,0,0,0,1080.315,1121.611Z",
    transform: "translate(-1072.807 -1113.176)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.835 22.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1548.362,1252.737a1.62,1.62,0,0,0,1.616-1.541l1.979-40.663a1.619,1.619,0,1,0-3.235-.158l-1.979,40.664a1.619,1.619,0,0,0,1.538,1.7Z",
    transform: "translate(-1546.742 -1208.834)",
    fill: "#ee9849"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1159.393,1445.829l1.81-10.895a1.348,1.348,0,0,1-1.284-1.347v-14.754a1.35,1.35,0,0,1,.494-1.044l10.976-9a1.35,1.35,0,1,1,1.711,2.087l-10.482,8.591v12.79l77.315,1.4,2.5-7.034a1.349,1.349,0,0,1,2.543.9l-2.374,6.684,10.382,4.056a1.349,1.349,0,1,1-.982,2.514l-11.29-4.41-1.62-.029-7.262,10.427c-.375.538-1.075.174-1.044-.543l.432-10.026-61.858-1.117-9.153,11.2C1159.884,1446.675,1159.306,1446.352,1159.393,1445.829Z",
    transform: "translate(-1139.137 -1339.425)",
    fill: "#2a4e96"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2141.5,1246.8h-45.6a3.574,3.574,0,0,0-3.574,3.574h0a3.574,3.574,0,0,0,3.574,3.574h20.467v22.7h4.662v-22.7H2141.5a3.574,3.574,0,0,0,3.574-3.574h0A3.574,3.574,0,0,0,2141.5,1246.8Z",
    transform: "translate(-1477.303 -748.244)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(511.409 473.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1619.639,1410.842h242.534v-60.853l-242.534-.607Z",
    transform: "translate(-1619.639 -1300.712)",
    fill: "#b74b42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 242.534,
    height: 15.914,
    transform: "translate(0 0)",
    fill: "#b74b42"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.735,0h271.6a5.735,5.735,0,0,1,5.735,5.735v0a5.735,5.735,0,0,1-5.735,5.735H5.735A5.735,5.735,0,0,1,0,5.735v0A5.735,5.735,0,0,1,5.735,0Z",
    transform: "translate(487.626 462.404)",
    fill: "#466aa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.584,1242.074l240.442.607v-33.362H1628.584Z",
    transform: "translate(-1115.083 -719.53)",
    fill: "#afcdfb",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.697 416.428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.562,0h9.523a2.562,2.562,0,0,1,2.562,2.562v0a2.562,2.562,0,0,1-2.562,2.562H2.562A2.562,2.562,0,0,1,0,2.562v0A2.562,2.562,0,0,1,2.562,0Z",
    transform: "translate(13.556)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H14.451a8.443,8.443,0,0,1,8.443,8.443v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(11.279 9.293)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.377,999.708h-48.746v-28.24h29.328a7.414,7.414,0,0,1,6.551,3.944Z",
    transform: "translate(-1818.169 -953.732)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.091,999.708h-48.747V973.274a1.806,1.806,0,0,1,1.806-1.806h27.522a7.414,7.414,0,0,1,6.551,3.944Z",
    transform: "translate(-1777.344 -953.732)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.992,0H14.451a8.443,8.443,0,0,1,8.443,8.443v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.992A2.992,2.992,0,0,1,2.992,0Z",
    transform: "translate(7.463 9.293)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.354,
    height: 4.169,
    transform: "translate(18.018 5.123)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.562,0h9.523a2.562,2.562,0,0,1,2.562,2.562v0a2.562,2.562,0,0,1-2.562,2.562H2.562A2.562,2.562,0,0,1,0,2.562v0A2.562,2.562,0,0,1,2.562,0Z",
    transform: "translate(11.894)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.631,
    height: 2.339,
    transform: "translate(14.018 1.169)",
    fill: "#365da4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureOpacityGroup);
export default __webpack_public_path__ + "static/media/furnitureOpacityGroup.449878bc6601e866861530010e6a085b.svg";
export { ForwardRef as ReactComponent };